import { render, staticRenderFns } from "./AnimationButton.vue?vue&type=template&id=5496b1c2&scoped=true&"
import script from "./AnimationButton.vue?vue&type=script&lang=js&"
export * from "./AnimationButton.vue?vue&type=script&lang=js&"
import style0 from "./AnimationButton.vue?vue&type=style&index=0&id=5496b1c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5496b1c2",
  null
  
)

export default component.exports